import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import {
  connectorAbortGenerator,
  connectorRequestGenerator,
} from 'redpoints-front-common/middlewares';

import reducers from '../reducers';
import {
  APPLICATION_SUITE,
  APPLICATION_TOKEN,
  ENVIRONMENT,
  SCHEME,
} from '../config/constants';

const configureStore = () => {
  const initialState = {};
  const enhancers = [];
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension({ name: '- IPR frontoffice -' }));
  }

  const composedEnhancers = compose(
    applyMiddleware(
      thunk,
      connectorAbortGenerator,
      connectorRequestGenerator({
        APPLICATION_SUITE,
        APPLICATION_TOKEN,
        ENVIRONMENT,
        SCHEME,
      })
    ),
    ...enhancers
  );

  const store = createStore(reducers, initialState, composedEnhancers);

  return { store };
};

export default configureStore;
